namespace TabAurous.Administration {
    export interface DocumentReportsRow {
        ReportId?: number;
        DocumentId?: number;
        ReportName?: string;
        ReportKey?: string;
        ReportFile?: string;
    }

    export namespace DocumentReportsRow {
        export const idProperty = 'ReportId';
        export const nameProperty = 'ReportName';
        export const localTextPrefix = 'Administration.DocumentReports';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = '*';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            ReportId = "ReportId",
            DocumentId = "DocumentId",
            ReportName = "ReportName",
            ReportKey = "ReportKey",
            ReportFile = "ReportFile"
        }
    }
}
